export const BASE_PATH = `${process.env.REACT_APP_MY_API_KEY}`;
export const BASE_HOME = `${process.env.REACT_APP_SERVICE_DODASHBOARD}`
export const BASE_DOMAIN = `${process.env.REACT_APP_BASE_DOMAIN}`;
export const BASE_PERSONAL = `${process.env.REACT_APP_SERVICE_DOPERSONALBOARD}`
export const BASE_MY_WORKFLOW = `${process.env.REACT_APP_SERVICE_DOBPMN}/my-workflow?type=wait&doGroupId=all`
export const SERVICE_DOREQUEST = `${process.env.REACT_APP_SERVICE_DOREQUEST}`

export const BASE_EDITOR = `${process.env.REACT_APP_SERVICE_DOEDITOR}`
